/*
  DEZE ERROR:

  Invalid prop: type check failed for prop "template". Expected Object, got Null  

  KOMT ALLEEN VOOR ALS JE TIJDENS HET DEBUGGEN EEN FILE OPSLAAT. GEEN ISSUE BIJ EEN BUILD DUS

*/

/* eslint-disable class-methods-use-this */
import Axios from "axios";
import {
  cacheAdapterEnhancer,
  throttleAdapterEnhancer,
} from "axios-extensions";
import page from "page";
import { inject } from "vue";
import { gsap } from "gsap";

/**
 Based on page.js. 
 Example here: http://smalljs.org/client-side-routing/page/ 
*/
export default class Router {
  constructor(options) {
    // Configure
    this.prefetch = options.prefetch || false;
    this.inTransition = false;
    this.transition = "default";
    this.updatePage = options.updatePage;

    this.emitter = inject("emitter");
    this.currentlyLoadedPath = "";

    // Initialize
    this.init();
  }

  init() {
    // Register page routes
    page("/", this.transitionToNextPage.bind(this));
    page("*", this.transitionToNextPage.bind(this));

    // Start page.js, without first dispatch
    page.start({ dispatch: false, popstate: true });

    // Enhance the original axios adapter with throttle and cache enhancer
    // temporalry disabled
    this.http = Axios.create({
      baseURL: "/",
      headers: {
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest",
      },
      adapter: throttleAdapterEnhancer(
        cacheAdapterEnhancer(Axios.defaults.adapter)
      ),
    });
  }

  transitionToNextPage(ctx) {
    // Leave if we are already in transition
    if (this.inTransition) {
      return;
    }

    // // Leave if we are on that route already
    if (ctx.path === this.currentlyLoadedPath) {
      window.scrollTo(0, 0);

      return;
    }

    this.currentlyLoadedPath = ctx.path;

    document.body.classList.add("lockScroll");
    document.body.classList.add("loading");

    // Set inTransition state
    this.inTransition = true;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let that = this;

    /* ANIMATE OUT OLD PAGE */
    this.animateOutCurrentPage = new gsap.timeline()
      .to(".pagecontainer ,.navigation__main_menu_label", {
        y: -400,
        ease: "power2.in",
        duration: 1,
      })
      .to(
        ".navigation__side_menu_item, .latest_news__toggle",
        { autoAlpha: 0, duration: 1 },
        0
      )
      .to(
        ".pagecontainer",
        {
          autoAlpha: 0,
          duration: 0.75,
        },
        "-=0.75"
      )

      .add(function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore:next-line
        that.emitter.emit("old-page-removed");
      });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore:next-line
    this.emitter.emit("pagewrapper-background-animation--start", 1);

    const path =
      process.env.NODE_ENV === "development"
        ? `https://nederlands-mijnmuseum.local/${ctx.path}`
        : ctx.path;

    this.http
      .get(path)
      .then((response) => {
        let formattedRepsonse = response.data.replaceAll("&quot;", '"');

        formattedRepsonse = formattedRepsonse.replaceAll("\\&#039;", '"'); // fix links (helpers.php)

        this.updatePage(ctx.path, formattedRepsonse);

        document.title = response.headers.title;

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore:next-line
        that.emitter.emit("new-page-loaded");

        if (window.gtag !== undefined && typeof window.gtag === "function") {
          window.gtag("set", "page_path", window.location.pathname);
          window.gtag("event", "page_view");
        }
      })
      .catch(() => {
        // maybe CORS issues while developing on localhost?
        // Open Chrome without CORS
        // open -n -a /Applications/Google\ Chrome.app/Contents/MacOS/Google\ Chrome --args --user-data-dir="/tmp/chrome_dev_test" --disable-web-security

        document.body.classList.remove("lockScroll");

        // just navigate the router to the given url
        if (process.env.NODE_ENV === "production") {
          window.location = ctx.path;
        }
      })
      .finally(() => {
        document.body.classList.remove("loading");
        that.inTransition = false;
      });
  }
}
